import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { ProgrammeReparationService } from 'src/app/_services/maintenance-service/programme_reparation/programme-reparation.service';
import { NotifService } from 'src/app/_services/notif.service';
import Swal from 'sweetalert2';
declare const $;
@Component({
  selector: 'app-programme-reparation-all',
  templateUrl: './programme-reparation-all.component.html',
  styleUrls: ['./programme-reparation-all.component.scss']
})
export class ProgrammeReparationAllComponent implements OnInit {

  programme_reparations: any;
  loading: boolean = true;
  @BlockUI() blockUI: NgBlockUI;

  //SweetAlert Text
  areYouSure = '';
  warning = ''
  yes = '';
  no = '';
  deleted = '';
  deletedMessage = '';
  cancelled = '';
  cancelledMessage = '';
  canCreate = false;
  canUpdate = false;
  canDelete = false;
  page = 1;
  data: any;

  constructor(
    private ProgrammeReparationService: ProgrammeReparationService,
    private authService: AuthService,
    private notifService: NotifService,
    private translate: TranslateService,
    private router: Router,
  ) {
    this.translate.get(
      ['SweetAlert.AreYouSure', 'SweetAlert.Warning', 'SweetAlert.Yes', 'SweetAlert.No', 'SweetAlert.Deleted',
        'SweetAlert.DeletedMessage', 'SweetAlert.Cancelled', 'SweetAlert.CancelledMessage'],
      { data: "ce programme de reparation" })
      .subscribe(val => {
        this.areYouSure = val['SweetAlert.AreYouSure'];
        this.warning = val['SweetAlert.Warning'];
        this.yes = val['SweetAlert.Yes'];
        this.no = val['SweetAlert.No'];
        this.deleted = val['SweetAlert.Deleted'];
        this.deletedMessage = val['SweetAlert.DeletedMessage'];
        this.cancelled = val['SweetAlert.Cancelled'];
        this.cancelledMessage = val['SweetAlert.CancelledMessage'];
      });
  }

  ngOnInit(): void {
    console.log('junie')
    this.getProgrammeReparation(this.page);
    const permissionSuffix = 'programme_reparations';
    this.canCreate = this.authService.hasPermission(`${permissionSuffix}-create`);
    this.canUpdate = this.authService.hasPermission(`${permissionSuffix}-update`);
    this.canDelete = this.authService.hasPermission(`${permissionSuffix}-delete`);
  }

  getProgrammeReparation(page) {
    this.loading = true;
    this.ProgrammeReparationService.gets(page).then(
      response => {
        this.programme_reparations = response;
        console.log(this.programme_reparations);
        $(function () {
          //$("#example1").DataTable().fnDestroy()
          $("#example1").DataTable({
            "responsive": true, "lengthChange": false, "autoWidth": false,
            "buttons": ["copy", "csv", "excel", "pdf", "print", "colvis"]
          }).buttons().container().appendTo('#example1_wrapper .col-md-6:eq(0)');
        });
      }
    ).catch(
      error => {
        this.notifService.danger(error.error.message)
      }
    ).finally(
      () => {
        this.loading = false;
      }
    );
  }


  getPage(url) {
    if (url) {
      this.ProgrammeReparationService.get(url).then((res) => {
        this.programme_reparations = res;
        console.log(this.programme_reparations);
      }).catch(
        error => {
          this.notifService.danger(error.error.message);
        }
      ).finally(
        () => {
          this.loading = false;
        }
      )
    }
  }


  editProgramme(id) {
    console.log('bonjour');
    this.router.navigate(['/programme-reparation/update/' + id]);

  }

  detailsProgramme(id) {
    console.log('bonjour');
    this.router.navigate(['/programme-reparation/detail/' + id]);
  }

  deleteProgramme(id) {
    Swal.fire({
      title: this.areYouSure,
      text: this.warning,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.yes,
      cancelButtonText: this.no
    }).then((result) => {
      if (result.value) {
        this.blockUI.start('Loading...');
        this.ProgrammeReparationService.delete(id).then(
          data => {
            this.blockUI.stop();
            Swal.fire(
              this.deleted,
              this.deletedMessage,
              'success'
            );
            this.getProgrammeReparation(1);

          }
        ).catch(
          error => {
            console.log(error);
            this.blockUI.stop();
            this.translate.get('ProgrammeReparation.' + error.error.code)
              .subscribe(val => this.notifService.danger(val));
          }
        );

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          this.cancelled,
          this.cancelledMessage,
          'error'
        );
      }
    });
  }

}
